import { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/admin/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(email.trim().toLowerCase(), password);
      toast.success("Welcome back.");
      navigate("/admin/dashboard");
    } catch (err) {
      const detail = err?.response?.data?.detail;
      const msg = typeof detail === "string" ? detail : "Login failed.";
      toast.error(msg);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-7rem)] flex items-center justify-center px-4 py-16" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl border border-[#E5E0D8] p-10 shadow-sm">
          <div className="w-14 h-14 rounded-2xl bg-[#F5F2EB] flex items-center justify-center mb-6 mx-auto">
            <Lock className="w-6 h-6 text-[#B8860B]" />
          </div>
          <h1 className="font-display text-3xl font-semibold text-center text-[#1A1A1A]">Admin Sign In</h1>
          <p className="text-sm text-[#6B6B6B] text-center mt-2">Internal access only.</p>

          <form onSubmit={onSubmit} className="mt-8 space-y-5">
            <div>
              <label className="label-x">Email</label>
              <input type="email" className="input-x" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" />
            </div>
            <div>
              <label className="label-x">Password</label>
              <input type="password" className="input-x" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" />
            </div>
            <button type="submit" disabled={submitting} className="btn-primary w-full justify-center" data-testid="admin-login-submit">
              {submitting ? "Signing in…" : "Sign In"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
